import * as machineRelationsShort from './short'

import * as planograms from 'app/mocks/data/machines/planograms/full'

import { MachineRelation } from 'app/types/park/machineRelation'

export const machineRelation1: MachineRelation = {
    ...machineRelationsShort.machineRelationShort1,
    distributors: [planograms.planogram1],
    lockers: [planograms.planogram2, planograms.planogram3],
    weighted_fridges: [],
}

export const machineRelation2: MachineRelation = {
    ...machineRelationsShort.machineRelationShort2,
    distributors: [],
    lockers: [],
    weighted_fridges: [planograms.planogram4],
}

export const machineRelation3: MachineRelation = {
    ...machineRelationsShort.machineRelationShort3,
    distributors: [],
    lockers: [],
    weighted_fridges: [planograms.planogram5],
}

export const machineRelation4: MachineRelation = {
    ...machineRelationsShort.machineRelationShort4,
    distributors: [planograms.planogram6],
    lockers: [planograms.planogram7, planograms.planogram8],
    weighted_fridges: [],
}

export const machineRelation5: MachineRelation = {
    ...machineRelationsShort.machineRelationShort5,
    distributors: [],
    lockers: [],
    weighted_fridges: [planograms.planogram9],
}

export const machineRelation6: MachineRelation = {
    ...machineRelationsShort.machineRelationShort6,
    distributors: [],
    lockers: [planograms.planogram10],
    weighted_fridges: [],
}
